import React from "react";
import ReactDOM from "react-dom";
import "../../index.css";

import WebFontLoader from "webfontloader";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import { grey500, grey900 } from "material-ui/styles/colors";

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: grey900,
    primary2Color: grey500,
    primary3Color: grey500,
    primary4Color: grey500,
    accent1Color: grey500,
    accent2Color: grey500,
    accent3Color: grey500
  },
  appBar: {
    height: 50,
    color: grey500
  }
});

WebFontLoader.load({
  google: {
    families: ["Roboto:300,400,500,700", "Material Icons"]
  }
});

const ThemedApp = props => <MuiThemeProvider muiTheme={muiTheme}>{props.children}</MuiThemeProvider>;

export default ThemedApp;



// WEBPACK FOOTER //
// ./src/components/ThemeProvider/component.js